import React, { useCallback, useState } from 'react';

// React Qr Code
import QRCode from 'react-qr-code';

// Reat to print
import { useReactToPrint } from 'react-to-print';

// Redux
import { useDispatch } from 'react-redux';

// Material
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

// Material Icons

// Actions
import { setSecondClose } from 'store/ducks/dialogs/actions';

// Helpers
import {
  formatDateString,
  getHoursFromToIoSoDate,
  getMinutesFromToIoSoDate,
} from 'helpers';
import { formatDocument } from 'helpers/document';
import { getStorageLineList, getStorageUserClaims } from 'helpers/ticketSales';

// Constants
import ENVIRONMENTS from 'constants/enviroments';

// components
import { pageStyle } from 'components';

// Icons
import { Close, Copy } from 'icons/Tools_Interface';
import { Bus, FerryFill } from 'icons/Location_Transport';

// Styles
import useStyles from './styles';
import { Print } from 'icons/Tech_Web_Device';

interface PixInterface {
  qrCode?: string;
  item: {
    TripSchedule?: {
      ScheduleMatrixConfig?: {
        LineSection?: {
          lineId?: string;
          name?: string;
        };
      };
      date?: string;
      open?: string;
      start?: string;
    };
  };
}

const Pix: React.FC<PixInterface> = ({ qrCode, item }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const userClaims = getStorageUserClaims();
  const storegeLineList = JSON.parse(getStorageLineList());
  const IS_SHIP = ENVIRONMENTS.TICKET_SALES.ITINERARY_TYPE === 'ship';

  const [componentRef, setComponentRef] = useState<any>();

  const reactToPrintContent = useCallback(() => componentRef, [componentRef]);

  const handlePrintPdf = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: 'Bilhete de Passagem Reservado',
    onAfterPrint: () => {
      document.body.style.zoom = '100%';
    },
    pageStyle,
    removeAfterPrint: true,
  });

  return (
    <Box>
      <Grid ref={(ref) => setComponentRef(ref)}>
        <Box
          display='flex'
          alignItems='center'
          justifyContent='flex-end'
          width='100%'>
          <IconButton onClick={() => dispatch(setSecondClose())}>
            <Close width='1rem' height='1rem' />
          </IconButton>
        </Box>
        <Box>
          <Typography variant='h6' className={classes.item}>
            Dados da Viagem
          </Typography>
          <Typography className={classes.item}>
            Linha:{' '}
            {storegeLineList.find(
              (e: { id: string; name: string }) =>
                e.id ===
                item.TripSchedule?.ScheduleMatrixConfig?.LineSection?.lineId,
            )?.name || '---'}
          </Typography>
          <Typography className={classes.item}>
            Trecho:{' '}
            {item.TripSchedule?.ScheduleMatrixConfig?.LineSection?.name ||
              '---'}
          </Typography>
          <Box display='flex' alignItems='center' pt='0.5rem'>
            <Typography
              className={classes.item}
              style={{ marginRight: '0.25rem' }}>
              Partida:
            </Typography>
            <Typography
              className={classes.item}
              style={{ marginRight: '1rem' }}>
              {formatDateString(item.TripSchedule?.date || '')}
            </Typography>
            <Box display='flex' alignItems='center'>
              {IS_SHIP && (
                <Typography className={classes.item}>
                  {getHoursFromToIoSoDate(item.TripSchedule?.open || '')}:
                  {getMinutesFromToIoSoDate(item.TripSchedule?.open || '')}
                </Typography>
              )}
              <Box p='0.5rem'>
                {IS_SHIP ? (
                  <FerryFill fill='#0094FF' width='1.25rem' height='1.25rem' />
                ) : (
                  <Bus fill='#0094FF' width='1.25rem' height='1.25rem' />
                )}
              </Box>
              <Typography className={classes.item}>
                {getHoursFromToIoSoDate(item.TripSchedule?.start || '')}:
                {getMinutesFromToIoSoDate(item.TripSchedule?.start || '')}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box pt='1rem'>
          <Typography variant='h6' className={classes.item}>
            Dados do Usuário
          </Typography>
          <Typography className={classes.item}>
            Nome: {JSON.parse(userClaims)?.claims?.name || '---'}
          </Typography>
          <Typography className={classes.item}>
            Documento:{' '}
            {JSON.parse(userClaims)?.document
              ? formatDocument(0, JSON.parse(userClaims)?.document)
              : '---'}
          </Typography>
        </Box>

        <Box pb='1rem' p='1rem'>
          <QRCode value={qrCode || ''} />
        </Box>
      </Grid>
      <Box display='grid'>
        <Button className={classes.copyCodeButton} onClick={handlePrintPdf}>
          <Print width='1rem' height='1rem' fill='#fff' />
          <Typography
            style={{
              fontSize: '0.9rem',
              paddingLeft: '0.5rem',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}>
            Imprimir
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default Pix;
export { Pix };
